export enum SearchType {
    PROGRAMME_SEARCH = "programme_search",
    UNIVERSITY_SEARCH = "university_search",
    SCHOLARSHIP_SEARCH = "scholarship_search"
}
